export default __webpack_public_path__ + "static/media/pink.13d513e7.png";